// istanbul ignore file

import type { HostActions } from '@makemydeal/dr-activities-change-vehicle';
import { CDL_V3_EVENT } from '@makemydeal/dr-shared-types';

export const hostActions: HostActions = {
    navigateToDashboard: () => ({ type: 'UNKNOWN' }), // @TODO: to be implemented in further tasks
    // Unreachable here: this app mounts no footer, so nothing calls it. A row's apply request is carried to the
    // host by the middleware's SET_APPLY_VEHICLE_REQUESTED case instead.
    switchVehicle: () => ({ type: 'UNKNOWN' }),
    forwardCDLEvent: (cdlPayload: any) => ({
        type: CDL_V3_EVENT,
        payload: cdlPayload
    })
};
